import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, resolveDirective as _resolveDirective, vModelText as _vModelText, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/QuoteOnly.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-bc251734")

_pushScopeId("data-v-bc251734")
const _hoisted_1 = {
  key: 1,
  class: "order-details-header"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "toOrderList container" }
const _hoisted_5 = {
  class: "container order-details",
  id: "order-details"
}
const _hoisted_6 = { class: "row order-info-block-row" }
const _hoisted_7 = { class: "col-12 col-lg-7" }
const _hoisted_8 = {
  key: 0,
  class: "order-info-block order-info-block-left-new"
}
const _hoisted_9 = {
  key: 1,
  class: "order-info-block order-info-block-left order-signed-wrapper"
}
const _hoisted_10 = {
  key: 0,
  class: "order-signed"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "order-info-block-left-row1" }
const _hoisted_14 = { class: "order-info-block-item pt-2" }
const _hoisted_15 = { class: "after-colon" }
const _hoisted_16 = { class: "order-info-block-item" }
const _hoisted_17 = { class: "after-colon" }
const _hoisted_18 = { class: "order-info-block-item" }
const _hoisted_19 = { class: "after-colon" }
const _hoisted_20 = { class: "white-space-nowrap" }
const _hoisted_21 = { class: "order-info-block-item" }
const _hoisted_22 = { class: "after-colon" }
const _hoisted_23 = { class: "white-space-nowrap" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "ti15 orderNumberTitle" }
const _hoisted_26 = { class: "order-number-with-lead-row" }
const _hoisted_27 = { class: "ti15 orderNumberValue" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("(Lead# ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_31 = { class: "button-container" }
const _hoisted_32 = { class: "edit-customer" }
const _hoisted_33 = { class: "icon-f icon-pencil-edit fs-20" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "icon-f icon-delete-cross fs-14 ml-2" }, null, -1)
const _hoisted_35 = { style: {"width":"min-content","display":"inline-flex"} }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "icon-f icon-check fs-16 ml-2" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "icon-f icon-check fs-16 ml-2" }, null, -1)
const _hoisted_38 = { class: "edit-customer" }
const _hoisted_39 = { class: "white-space-nowrap" }
const _hoisted_40 = { class: "order-info-block-double" }
const _hoisted_41 = { class: "order-info-block-item" }
const _hoisted_42 = { class: "after-colon" }
const _hoisted_43 = {
  key: 0,
  class: "order-info-block-item",
  style: {"padding-inline-end":"10px"}
}
const _hoisted_44 = { class: "after-colon" }
const _hoisted_45 = {
  key: 1,
  class: "order-info-block-item"
}
const _hoisted_46 = { class: "after-colon" }
const _hoisted_47 = {
  key: 0,
  class: "router-link"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "order-info-block-item2" }
const _hoisted_50 = { class: "order-info-block-item" }
const _hoisted_51 = { class: "after-colon" }
const _hoisted_52 = { class: "order-info-block-item2" }
const _hoisted_53 = { class: "after-colon" }
const _hoisted_54 = { class: "single-ellipsis" }
const _hoisted_55 = {
  key: 2,
  class: "order-info-block-item"
}
const _hoisted_56 = { class: "after-colon" }
const _hoisted_57 = {
  key: 3,
  class: "order-info-block-item"
}
const _hoisted_58 = {
  key: 4,
  class: "order-info-block-item"
}
const _hoisted_59 = {
  key: 5,
  class: "order-info-block-item"
}
const _hoisted_60 = { class: "col-12 col-lg-5" }
const _hoisted_61 = { class: "order-info-block order-info-block-right" }
const _hoisted_62 = { class: "order-price-row" }
const _hoisted_63 = { class: "price-label-style" }
const _hoisted_64 = { class: "label-item-style" }
const _hoisted_65 = {
  key: 0,
  class: "order-price-row"
}
const _hoisted_66 = { class: "price-label-style" }
const _hoisted_67 = { class: "label-item-style" }
const _hoisted_68 = {
  key: 1,
  class: "order-price-row"
}
const _hoisted_69 = { class: "price-label-style" }
const _hoisted_70 = { class: "label-item-style" }
const _hoisted_71 = { class: "order-price-row" }
const _hoisted_72 = { class: "price-label-style" }
const _hoisted_73 = { class: "label-item-style" }
const _hoisted_74 = { class: "order-discountAmount" }
const _hoisted_75 = {
  key: 2,
  class: "order-price-row"
}
const _hoisted_76 = { class: "price-label-style after-colon" }
const _hoisted_77 = { class: "label-item-style" }
const _hoisted_78 = {
  key: 3,
  class: "order-price-row"
}
const _hoisted_79 = { class: "price-label-style after-colon" }
const _hoisted_80 = { class: "label-item-style" }
const _hoisted_81 = { class: "order-price-row" }
const _hoisted_82 = { class: "price-label-style" }
const _hoisted_83 = { class: "label-item-style" }
const _hoisted_84 = {
  key: 4,
  class: "order-price-row"
}
const _hoisted_85 = { class: "price-label-style" }
const _hoisted_86 = { class: "label-item-style" }
const _hoisted_87 = {
  key: 5,
  class: "order-price-row"
}
const _hoisted_88 = { class: "price-label-style" }
const _hoisted_89 = { class: "label-item-style" }
const _hoisted_90 = {
  key: 0,
  class: "price-to-customer"
}
const _hoisted_91 = { class: "order-products-block" }
const _hoisted_92 = { class: "order-products-header" }
const _hoisted_93 = {
  key: 0,
  src: _imports_0
}
const _hoisted_94 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-22 browse-icon" }, null, -1)
const _hoisted_95 = {
  key: 0,
  class: "new-order-products-empty"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-22 browse-icon" }, null, -1)
const _hoisted_97 = {
  key: 1,
  class: "order-product-items"
}
const _hoisted_98 = { class: "order-product-item-less" }
const _hoisted_99 = { class: "order-product-name" }
const _hoisted_100 = { class: "order-product-date" }
const _hoisted_101 = { class: "order-product-total" }
const _hoisted_102 = { class: "product-price-label" }
const _hoisted_103 = { class: "order-product-customers single-ellipsis" }
const _hoisted_104 = {
  key: 0,
  class: "order-product-customer-coupon"
}
const _hoisted_105 = /*#__PURE__*/_createVNode("span", { class: "icon-f icon-coupon fs-14 cursor-initial" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon-f path1 fs-16 cursor-initial" }),
  /*#__PURE__*/_createVNode("span", { class: "icon-f path2 fs-16 cursor-initial" })
], -1)
const _hoisted_106 = { class: "product-customer-rows" }
const _hoisted_107 = { class: "product-customer-row1" }
const _hoisted_108 = { class: "product-customer-type" }
const _hoisted_109 = { class: "product-customer-type-label" }
const _hoisted_110 = { class: "product-customer-type-value" }
const _hoisted_111 = { class: "product-customer-date" }
const _hoisted_112 = { class: "product-customer-date-label" }
const _hoisted_113 = {
  key: 0,
  class: "data-passed"
}
const _hoisted_114 = {
  key: 0,
  class: "product-customer-row-edit"
}
const _hoisted_115 = { class: "product-customer-editable-items" }
const _hoisted_116 = { class: "product-customer-edit" }
const _hoisted_117 = { class: "product-customer-edit-label" }
const _hoisted_118 = { class: "product-customer-edit product-customer-edit-perUnit" }
const _hoisted_119 = { class: "product-customer-edit-label" }
const _hoisted_120 = {
  key: 1,
  class: "product-customer-edit-value"
}
const _hoisted_121 = { class: "product-customer-edit" }
const _hoisted_122 = { class: "product-customer-edit-label" }
const _hoisted_123 = { class: "customer-total-pay" }
const _hoisted_124 = { class: "customer-edit-actions" }
const _hoisted_125 = {
  key: 1,
  class: "product-customer-row2"
}
const _hoisted_126 = { class: "customer-price-item" }
const _hoisted_127 = { class: "customer-price-item-label" }
const _hoisted_128 = { class: "customer-price-item-value" }
const _hoisted_129 = { class: "customer-price-item" }
const _hoisted_130 = { class: "customer-price-item-label" }
const _hoisted_131 = { class: "customer-price-item-value" }
const _hoisted_132 = { class: "customer-price-item" }
const _hoisted_133 = { class: "customer-price-item-label" }
const _hoisted_134 = { class: "customer-price-item-value" }
const _hoisted_135 = { class: "customer-price-item" }
const _hoisted_136 = { class: "customer-price-item-label" }
const _hoisted_137 = { class: "customer-price-item-value" }
const _hoisted_138 = { class: "order-remarks-row" }
const _hoisted_139 = { class: "order-remarks-header" }
const _hoisted_140 = { class: "order-remarks-block" }
const _hoisted_141 = {
  key: 0,
  class: "order-remarks-value"
}
const _hoisted_142 = { class: "edit-order-remarks-pencil" }
const _hoisted_143 = {
  key: 1,
  class: "order-add-remark"
}
const _hoisted_144 = {
  key: 1,
  class: "order-tags-row"
}
const _hoisted_145 = { class: "row grid-div-header" }
const _hoisted_146 = { class: "col-12" }
const _hoisted_147 = { class: "row" }
const _hoisted_148 = { class: "col-6 col-lg-3" }
const _hoisted_149 = {
  class: "fs-20",
  style: {"line-height":"44px"}
}
const _hoisted_150 = { class: "col-6 col-lg-9 text-end" }
const _hoisted_151 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-22 browse-icon" }, null, -1)
const _hoisted_152 = /*#__PURE__*/_createVNode("hr", { style: {"margin-bottom":"20px"} }, null, -1)
const _hoisted_153 = { class: "row grid-div-body" }
const _hoisted_154 = { class: "col-12" }
const _hoisted_155 = { class: "row" }
const _hoisted_156 = { class: "col-12 order-tags-container" }
const _hoisted_157 = { class: "order-tag-name" }
const _hoisted_158 = {
  key: 2,
  class: "chat-block",
  id: "order-chat"
}
const _hoisted_159 = { class: "messages-block-header" }
const _hoisted_160 = { class: "messages-block-title" }
const _hoisted_161 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-chat" }, null, -1)
const _hoisted_162 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-settings" }, null, -1)
const _hoisted_163 = { class: "messages-block-info" }
const _hoisted_164 = { class: "messages-block-container" }
const _hoisted_165 = { class: "msg-title" }
const _hoisted_166 = { key: 0 }
const _hoisted_167 = { key: 1 }
const _hoisted_168 = { key: 2 }
const _hoisted_169 = { class: "msg-text-block" }
const _hoisted_170 = {
  key: 0,
  class: "msg-text"
}
const _hoisted_171 = {
  key: 1,
  class: "msg-text"
}
const _hoisted_172 = { class: "send-telegram-block" }
const _hoisted_173 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-telegram fs-24" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_QuoteActions = _resolveComponent("QuoteActions")
  const _component_OrderActions = _resolveComponent("OrderActions")
  const _component_OrderArrivalConfirmationActions = _resolveComponent("OrderArrivalConfirmationActions")
  const _component_OrderHeader = _resolveComponent("OrderHeader")
  const _component_OrderDataView = _resolveComponent("OrderDataView")
  const _component_router_link = _resolveComponent("router-link")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_OrderMobileActionsFooter = _resolveComponent("OrderMobileActionsFooter")
  const _component_ContractFormModal = _resolveComponent("ContractFormModal")
  const _component_OverlayModal = _resolveComponent("OverlayModal")
  const _component_AddTagsModal = _resolveComponent("AddTagsModal")
  const _component_TagsManagementModal = _resolveComponent("TagsManagementModal")
  const _component_CrmCustomerChatMessagePopup = _resolveComponent("CrmCustomerChatMessagePopup")
  const _directive_tooltip = _resolveDirective("tooltip")

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: { isNewOrder: _ctx.isNew }
  }, [
    ((!_ctx.isNew && _ctx.isActionsExpand) || (!_ctx.isNew && _ctx.isQuoteActionsExpand) || _ctx.isArrivalConfirmationExpand)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["actions-background", { 'backdrop-blur': _ctx.actionsMenu == 'mobile' }],
          onClick: _cache[1] || (_cache[1] = 
                () => {
                    _ctx.isActionsExpand = false;
                    _ctx.isArrivalConfirmationExpand = false;
                    _ctx.isQuoteActionsExpand = false;
                }
            )
        }, null, 2))
      : _createCommentVNode("", true),
    (!_ctx.isNew && _ctx.isQuoteActionsExpand && _ctx.actionsMenu == 'mobile' && _ctx.isQuote)
      ? (_openBlock(), _createBlock(_component_QuoteActions, {
          key: 1,
          id: _ctx.id,
          class: "mobile-actions mx-auto",
          onOnSelectQuoteAction: _ctx.onSelectQuoteAction,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isQuoteActionsExpand = false))
        }, null, 8, ["id", "onOnSelectQuoteAction"]))
      : _createCommentVNode("", true),
    (!_ctx.isNew && _ctx.isActionsExpand && _ctx.actionsMenu == 'mobile' && !_ctx.isQuote)
      ? (_openBlock(), _createBlock(_component_OrderActions, {
          key: 2,
          id: _ctx.id,
          orderNumber: _ctx.order.orderNumber,
          orderStatus: _ctx.order.statusId,
          orderHasTicket: _ctx.order.orderHasTicket,
          class: "mobile-actions mx-auto",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isActionsExpand = false)),
          onChangeStatus: _ctx.changeStatus,
          onAssignEmployee: _ctx.assignEmployee,
          onUnassignEmployee: _ctx.unassignEmployee,
          onClickContractFormModal: _ctx.updateContractFormModalVisibility,
          employeeIds: _ctx.order.employeeIds,
          onGetOrderDetails: _ctx.getOrderDetailsAfterChangeStatus,
          onCreateReceipt: _ctx.createReceipt,
          onCreateInvoice: _ctx.createInvoice,
          onCreatePerfomaInvoice: _ctx.createPerfomaInvoice
        }, null, 8, ["id", "orderNumber", "orderStatus", "orderHasTicket", "onChangeStatus", "onAssignEmployee", "onUnassignEmployee", "onClickContractFormModal", "employeeIds", "onGetOrderDetails", "onCreateReceipt", "onCreateInvoice", "onCreatePerfomaInvoice"]))
      : _createCommentVNode("", true),
    (!_ctx.isNew && _ctx.isArrivalConfirmationExpand && _ctx.actionsMenu == 'mobile' && !_ctx.isQuote)
      ? (_openBlock(), _createBlock(_component_OrderArrivalConfirmationActions, {
          key: 3,
          class: "mobile-arrival-confirmation-actions m-auto",
          align: 'row',
          onSave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSaveArrivalConfirmation($event)))
        }))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: { 'display-none': _ctx.actionsMenu == 'mobile' && (_ctx.isActionsExpand || _ctx.isArrivalConfirmationExpand || _ctx.isQuoteActionsExpand) }
    }, [
      (_ctx.isNew)
        ? (_openBlock(), _createBlock(_component_OrderHeader, {
            key: 0,
            title: _ctx.isQuote ? _ctx.$t('button.newQuote') : _ctx.$t('button.newOrder'),
            formId: 'new-order-form-id',
            submitText: _ctx.isQuote ? _ctx.$t('button.create-quote') : _ctx.$t('button.create-order'),
            formDisabled: !_ctx.orderProductExist,
            onBack: _cache[5] || (_cache[5] = ($event: any) => (_ctx.back()))
          }, null, 8, ["title", "submitText", "formDisabled"]))
        : (_openBlock(), _createBlock("div", _hoisted_1, [
            (_ctx.isQuote)
              ? (_openBlock(), _createBlock("h1", _hoisted_2, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('quote.details.title', [_ctx.order.id, _ctx.order.leadCustomer.fullName])), 1)
                ]))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("h1", null, [
                    (_ctx.order.leadCustomer?.groupName)
                      ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.order.leadCustomer?.groupName) + " - ", 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.order.leadCustomer?.fullName ?? _ctx.$t('orders.orderDetails')), 1)
                  ]),
                  _createVNode("h2", null, _toDisplayString(_ctx.formatAmount(_ctx.order.priceTotal)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                ], 64)),
            _createVNode("div", _hoisted_4, [
              _createVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goBack())),
                type: "button"
              }, _toDisplayString(_ctx.$t('button.back')), 1)
            ])
          ])),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            (_ctx.isNew)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  (_ctx.loaded)
                    ? (_openBlock(), _createBlock("form", {
                        key: 0,
                        id: "new-order-form-id",
                        onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
                        novalidate: ""
                      }, [
                        _createVNode(_component_OrderDataView, {
                          modelValue: _ctx.order,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.order = $event)),
                          "order-product-exist": _ctx.orderProductExist,
                          channels: _ctx.channels,
                          loaded: _ctx.loaded,
                          priceTypes: _ctx.priceTypes,
                          clients: _ctx.clients,
                          "is-group-price": _ctx.isGroupPrice,
                          "incorrect-mobile": _ctx.incorrectMobile,
                          "incorrect-email": _ctx.incorrectEmail,
                          onEmailChanged: _ctx.emailChanged,
                          onMobileNumberChanged: _ctx.mobileNumberChanged,
                          onOnBussinessClientChange: _ctx.onBussinessClientChange
                        }, null, 8, ["modelValue", "order-product-exist", "channels", "loaded", "priceTypes", "clients", "is-group-price", "incorrect-mobile", "incorrect-email", "onEmailChanged", "onMobileNumberChanged", "onOnBussinessClientChange"])
                      ], 32))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_9, [
                  (_ctx.order.isCustomerContractFormSigned)
                    ? (_openBlock(), _createBlock("div", _hoisted_10))
                    : _createCommentVNode("", true),
                  _createVNode("div", {
                    class: ["order-status-block", _ctx.isQuote ? 'p-inline-start-25' : 't-center'],
                    style: { background: _ctx.OrderStatusColors[_ctx.order.statusId] }
                  }, [
                    (_ctx.isQuote)
                      ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.order.leadCustomer.fullName), 1))
                      : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t(_ctx.getFullNameOrderStatus(_ctx.order.status))), 1))
                  ], 6),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", null, [
                      (_ctx.isQuote)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('label.lead-id')), 1),
                              _createVNode("div", {
                                class: "white-space-nowrap crmCustomer router-link",
                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goToCrmCustomerLeadDetails && _ctx.goToCrmCustomerLeadDetails(...args)))
                              }, _toDisplayString(_ctx.order.crmCustomerLeadId), 1)
                            ]),
                            _createVNode("div", _hoisted_16, [
                              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('crm-customer.label.customer-id')), 1),
                              _createVNode("div", {
                                class: "white-space-nowrap crmCustomer router-link",
                                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goToCrmCustomerDetails && _ctx.goToCrmCustomerDetails(...args)))
                              }, _toDisplayString(_ctx.order.crmCustomerId), 1)
                            ]),
                            _createVNode("div", _hoisted_18, [
                              _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('label.first-name')), 1),
                              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.order.leadCustomer.firstName), 1)
                            ]),
                            _createVNode("div", _hoisted_21, [
                              _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('label.last-name')), 1),
                              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.order.leadCustomer.lastName), 1)
                            ])
                          ], 64))
                        : (_openBlock(), _createBlock("div", _hoisted_24, [
                            _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('orders.orderNumber')) + ":", 1),
                            _createVNode("div", _hoisted_26, [
                              _createVNode("div", _hoisted_27, _toDisplayString(_ctx.order.orderNumber || 0), 1),
                              (_ctx.order.crmCustomerLeadId)
                                ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createVNode(_component_router_link, {
                                      class: "text-link",
                                      style: {"text-decoration":"underline !important"},
                                      to: {
                                                            name: 'crm-customer-lead-details',
                                                            params: {
                                                                crmCustomerId: _ctx.order.crmCustomerId,
                                                                crmCustomerLeadId: _ctx.order.crmCustomerLeadId
                                                            }
                                                        }
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(_ctx.order.crmCustomerLeadId), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["to"]),
                                    _hoisted_30
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                    ]),
                    _createVNode("div", _hoisted_31, [
                      (_ctx.isQuote)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("button", {
                              type: "button",
                              class: "order-modify-button-wrapper",
                              style: {"background":"linear-gradient(180deg, #62A1C9 0%, #598EB4 100%)"},
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showQuoteActions && _ctx.showQuoteActions(...args)))
                            }, _toDisplayString(_ctx.$t('orders.quoteActions')), 1),
                            _createVNode("div", _hoisted_32, [
                              _withDirectives(_createVNode("i", _hoisted_33, null, 512), [
                                [_vShow, false]
                              ])
                            ])
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            (_ctx.order.arrivalConfirmationId === 0)
                              ? (_openBlock(), _createBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.arrivalConfirmation())),
                                  class: "order-modify-button-wrapper",
                                  style: {"background":"linear-gradient(180deg, #62A1C9 0%, #598EB4 100%)"}
                                }, _toDisplayString(_ctx.$t('order.arrivalConfirmation.none')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.order.arrivalConfirmationId === 1)
                              ? (_openBlock(), _createBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.arrivalConfirmation())),
                                  class: "arrival-btn",
                                  style: {"background-color":"#fd695a"}
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('order.arrivalConfirmation.notArrived')) + " ", 1),
                                  _hoisted_34
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.order.arrivalConfirmationId === 2)
                              ? (_openBlock(), _createBlock("button", {
                                  key: 2,
                                  type: "button",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.arrivalConfirmation())),
                                  class: "arrival-btn",
                                  style: {"background-color":"#f6ae28","display":"flex","align-items":"center","gap":"5px"}
                                }, [
                                  _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('order.arrivalConfirmation.arrivedPartially')), 1),
                                  _hoisted_36
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.order.arrivalConfirmationId === 3)
                              ? (_openBlock(), _createBlock("button", {
                                  key: 3,
                                  type: "button",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.arrivalConfirmation())),
                                  class: "arrival-btn"
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('order.arrivalConfirmation.arrived')) + " ", 1),
                                  _hoisted_37
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("button", {
                              type: "button",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.actions())),
                              class: "order-modify-button-wrapper edit-order"
                            }, _toDisplayString(_ctx.$t('orders.orderActions')), 1),
                            _createVNode("div", _hoisted_38, [
                              _createVNode("i", {
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.EditOrder())),
                                class: "icon-f icon-pencil-edit fs-20"
                              })
                            ])
                          ], 64))
                    ]),
                    (_ctx.isArrivalConfirmationExpand && _ctx.actionsMenu == 'desktop' && !_ctx.isQuote)
                      ? (_openBlock(), _createBlock(_component_OrderArrivalConfirmationActions, {
                          key: 0,
                          class: "desktop-arrival-confirmation-actions",
                          onSave: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onSaveArrivalConfirmation($event)))
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isActionsExpand && _ctx.actionsMenu == 'desktop' && !_ctx.isQuote)
                      ? (_openBlock(), _createBlock(_component_OrderActions, {
                          key: 1,
                          class: "desktop-actions",
                          id: _ctx.id,
                          orderNumber: _ctx.order.orderNumber,
                          orderStatus: _ctx.order.statusId,
                          orderHasTicket: _ctx.order.orderHasTicket,
                          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isActionsExpand = false)),
                          onChangeStatus: _ctx.changeStatus,
                          onAssignEmployee: _ctx.assignEmployee,
                          onUnassignEmployee: _ctx.unassignEmployee,
                          onClickContractFormModal: _ctx.updateContractFormModalVisibility,
                          employeeIds: _ctx.order.employeeIds,
                          onGetOrderDetails: _ctx.getOrderDetailsAfterChangeStatus,
                          onCreateReceipt: _ctx.createReceipt,
                          onCreateInvoice: _ctx.createInvoice,
                          onCreatePerfomaInvoice: _ctx.createPerfomaInvoice
                        }, null, 8, ["id", "orderNumber", "orderStatus", "orderHasTicket", "onChangeStatus", "onAssignEmployee", "onUnassignEmployee", "onClickContractFormModal", "employeeIds", "onGetOrderDetails", "onCreateReceipt", "onCreateInvoice", "onCreatePerfomaInvoice"]))
                      : _createCommentVNode("", true),
                    (_ctx.isQuoteActionsExpand && _ctx.actionsMenu == 'desktop' && _ctx.isQuote)
                      ? (_openBlock(), _createBlock(_component_QuoteActions, {
                          key: 2,
                          class: "desktop-actions",
                          id: _ctx.id,
                          onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isQuoteActionsExpand = false)),
                          onOnSelectQuoteAction: _ctx.onSelectQuoteAction
                        }, null, 8, ["id", "onOnSelectQuoteAction"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", {
                    class: ["order-info-block-item", { 'pt-2': !_ctx.isQuote }]
                  }, [
                    _createVNode("div", null, _toDisplayString(_ctx.$t('orders.createDate')) + ":", 1),
                    _createVNode("div", _hoisted_39, _toDisplayString(_ctx.formatLocalDateTimeIsrael(_ctx.order.createDate)), 1)
                  ], 2),
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _createVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('label.order-type')), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.orderType), 1)
                    ]),
                    (_ctx.order.leadCustomer?.pnr)
                      ? (_openBlock(), _createBlock("div", _hoisted_43, [
                          _createVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('cashier.label.ext-sys-number')), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.order.leadCustomer?.pnr), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.isQuote)
                    ? (_openBlock(), _createBlock("div", _hoisted_45, [
                        _createVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('label.customer_name')), 1),
                        _createVNode("div", {
                          onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.goToCrmCustomerDetails && _ctx.goToCrmCustomerDetails(...args)))
                        }, [
                          (_ctx.order.crmCustomerId)
                            ? (_openBlock(), _createBlock("span", _hoisted_47, _toDisplayString(_ctx.order.leadCustomer?.fullName), 1))
                            : (_openBlock(), _createBlock("span", _hoisted_48, _toDisplayString(_ctx.order.leadCustomer?.fullName), 1))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_49, [
                    _createVNode("div", _hoisted_50, [
                      _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('label.mobile')), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.order.leadCustomer?.mobile), 1)
                    ]),
                    _createVNode("div", _hoisted_52, [
                      _createVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('newOrder.email')), 1),
                      _createVNode("div", _hoisted_54, [
                        (_ctx.order.leadCustomer?.email)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              (_ctx.isQuote)
                                ? (_openBlock(), _createBlock("span", {
                                    key: 0,
                                    style: {"color":"#42AEE7","text-decoration-line":"underline","cursor":"pointer"},
                                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.openCrmCustomerChatMessageModal && _ctx.openCrmCustomerChatMessageModal(...args)))
                                  }, _toDisplayString(_ctx.order.leadCustomer.email), 1))
                                : (_openBlock(), _createBlock("a", {
                                    key: 1,
                                    class: "mailto",
                                    href: 'mailto:' + _ctx.order.leadCustomer.email
                                  }, _toDisplayString(_ctx.order.leadCustomer.email), 9, ["href"]))
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (_ctx.order.leadCustomer?.cityName)
                    ? (_openBlock(), _createBlock("div", _hoisted_55, [
                        _createVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('title.city')), 1),
                        _createVNode("div", null, _toDisplayString(_ctx.order.leadCustomer?.cityName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.order.leadCustomer?.subscribe != undefined)
                    ? (_openBlock(), _createBlock("div", _hoisted_57, [
                        _createVNode("div", null, _toDisplayString(_ctx.$t('order.subscribe')), 1),
                        _createVNode("div", null, _toDisplayString(_ctx.order.leadCustomer?.subscribe ? _ctx.$t('alert.yes') : _ctx.$t('alert.no')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.order.businessClientId)
                    ? (_openBlock(), _createBlock("div", _hoisted_58, [
                        _createVNode("div", null, _toDisplayString(_ctx.$t('label.business-client')), 1),
                        _createVNode("span", null, [
                          _createVNode(_component_router_link, {
                            class: "router-link",
                            to: {
                                            name: 'businessClientView',
                                            params: { id: _ctx.order.businessClientId, page: 1 }
                                        }
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.order.businessClientName), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.order.affiliateName)
                    ? (_openBlock(), _createBlock("div", _hoisted_59, [
                        _createVNode("div", null, _toDisplayString(_ctx.$t('label.affiliate-client')), 1),
                        _createVNode("div", null, _toDisplayString(_ctx.order.affiliateName), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _createVNode("div", _hoisted_60, [
            _createVNode("div", _hoisted_61, [
              _createVNode("div", _hoisted_62, [
                _createVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('newOrder.total')) + ":", 1),
                _createVNode("div", _hoisted_64, _toDisplayString(_ctx.formatAmount(_ctx.order.gross)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
              ]),
              (_ctx.order.commissionTotal)
                ? (_openBlock(), _createBlock("div", _hoisted_65, [
                    _createVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('newOrder.commission')) + ":", 1),
                    _createVNode("div", _hoisted_67, _toDisplayString(_ctx.formatPercentAmount(_ctx.order.commissionPercent)) + "%(" + _toDisplayString(_ctx.formatAmount(_ctx.order.commissionTotal)) + _toDisplayString(_ctx.order.currencySymbol) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.commissionTotal)
                ? (_openBlock(), _createBlock("div", _hoisted_68, [
                    _createVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('newOrder.net')) + ":", 1),
                    _createVNode("div", _hoisted_70, _toDisplayString(_ctx.formatAmount(_ctx.order.net)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_71, [
                _createVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('newOrder.discount')) + ":", 1),
                _createVNode("div", _hoisted_73, [
                  _createTextVNode(_toDisplayString(_ctx.formatPercentAmount(_ctx.order.discountPercent)) + "%", 1),
                  _createVNode("span", _hoisted_74, "(" + _toDisplayString(_ctx.formatAmount(_ctx.order.totalDiscountAmount)) + _toDisplayString(_ctx.order.currencySymbol) + ")", 1)
                ])
              ]),
              (_ctx.order.businessClientTotalAmount)
                ? (_openBlock(), _createBlock("div", _hoisted_75, [
                    _createVNode("div", _hoisted_76, _toDisplayString(_ctx.$t('label.total-after-discount')), 1),
                    _createVNode("div", _hoisted_77, _toDisplayString(_ctx.formatAmount(_ctx.order.priceTotal)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.businessClientTotalAmount)
                ? (_openBlock(), _createBlock("div", _hoisted_78, [
                    _createVNode("div", _hoisted_79, _toDisplayString(_ctx.$t('label.business-client-total')), 1),
                    _createVNode("div", _hoisted_80, _toDisplayString(_ctx.formatAmount(_ctx.order.businessClientTotalAmount)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_81, [
                _createVNode("div", _hoisted_82, _toDisplayString(_ctx.$t('newOrder.total-pay')), 1),
                _createVNode("div", _hoisted_83, _toDisplayString(_ctx.formatAmount(_ctx.order.totalToPay)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
              ]),
              (!_ctx.isQuote)
                ? (_openBlock(), _createBlock("div", _hoisted_84, [
                    _createVNode("div", _hoisted_85, _toDisplayString(_ctx.$t('newOrder.paid')), 1),
                    _createVNode("div", _hoisted_86, _toDisplayString(_ctx.formatAmount(_ctx.order.paid)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isQuote)
                ? (_openBlock(), _createBlock("div", _hoisted_87, [
                    _createVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('newOrder.balance')), 1),
                    _createVNode("div", _hoisted_89, _toDisplayString(_ctx.formatAmount(_ctx.order.ballance)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.order.products.length > 0 && !_ctx.isQuote)
          ? (_openBlock(), _createBlock("div", _hoisted_90, _toDisplayString(_ctx.$t('order.price-to-customer', [_ctx.formatAmount(_ctx.order.totalToPay), _ctx.order.currencySymbol])), 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_91, [
          _createVNode("div", _hoisted_92, [
            _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.products')), 1),
            (_ctx.isQuote && !_ctx.isNew)
              ? (_openBlock(), _createBlock("img", _hoisted_93))
              : _createCommentVNode("", true),
            (!_ctx.isNew || _ctx.order.products.length > 0)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  type: "button",
                  class: "add-new-order-product-btn",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.addProduct()))
                }, [
                  _hoisted_94,
                  _createTextVNode(_toDisplayString(_ctx.$t('newOrder.addAProduct')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.order.products.length == 0)
            ? (_openBlock(), _createBlock("div", _hoisted_95, [
                _createVNode("button", {
                  type: "button",
                  class: "add-new-order-product-btn",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addProduct()))
                }, [
                  _hoisted_96,
                  _createTextVNode(_toDisplayString(_ctx.$t('newOrder.addAProduct')), 1)
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_97, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order.products, (product) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "order-product-item",
                    key: product.productId
                  }, [
                    _createVNode("div", _hoisted_98, [
                      _createVNode("span", _hoisted_99, _toDisplayString(product.productName), 1),
                      _createVNode("span", _hoisted_100, _toDisplayString(_ctx.getDateToTitle(product.date)) + " " + _toDisplayString(_ctx.removemillis(product.startTime)) + " " + _toDisplayString(_ctx.getHoursMinutesSlotDuration(product.duration)), 1),
                      _createVNode("span", _hoisted_101, [
                        _createVNode("span", _hoisted_102, _toDisplayString(_ctx.$t('newOrder.total')) + ":", 1),
                        _createVNode("span", null, _toDisplayString(_ctx.formatAmount(product.price)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                      ]),
                      _createVNode("span", _hoisted_103, _toDisplayString(product.customersTotal), 1),
                      _createVNode("span", {
                        class: "order-product-more",
                        onClick: ($event: any) => (product.more = !product.more)
                      }, [
                        _createTextVNode(_toDisplayString(product.more ? _ctx.$t('btn.show-less') : _ctx.$t('btn.show-more')) + " ", 1),
                        _createVNode("span", {
                          class: [product.more ? 'icon-arrow-up' : 'icon-arrow-down', "icon-f fs-10"]
                        }, null, 2)
                      ], 8, ["onClick"])
                    ]),
                    (product.more)
                      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(product.customers, (customer, customerIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "order-product-item-more",
                            key: customer.id
                          }, [
                            (customer.couponId)
                              ? (_openBlock(), _createBlock("div", _hoisted_104, [
                                  _hoisted_105,
                                  _createVNode("span", null, _toDisplayString(customer.couponName), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_106, [
                              _createVNode("div", _hoisted_107, [
                                _createVNode("div", _hoisted_108, [
                                  _createVNode("div", _hoisted_109, _toDisplayString(_ctx.$t('customerType.customerType')) + ":", 1),
                                  _createVNode("div", _hoisted_110, [
                                    _withDirectives(_createVNode("span", null, _toDisplayString(customer.name), 513), [
                                      [
                                        _directive_tooltip,
                                        customer.name,
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_111, [
                                  _createVNode("div", _hoisted_112, _toDisplayString(_ctx.$t('details.date')) + ":", 1),
                                  _createVNode("div", {
                                    class: [{ 'product-customer-date-value-edit': customer.editMode }, "product-customer-date-value"],
                                    onClick: ($event: any) => (_ctx.changeOrderProductDate(customer, product.productId))
                                  }, _toDisplayString(_ctx.getDateToTitle(customer.date)) + " " + _toDisplayString(_ctx.removemillis(customer.slot.startTime)) + " " + _toDisplayString(_ctx.getHoursMinutesSlotDuration(customer.slot.duration)), 11, ["onClick"]),
                                  (customer.slotPassed)
                                    ? (_openBlock(), _createBlock("div", _hoisted_113, _toDisplayString(_ctx.$t('label.passed')), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (customer.editMode)
                                ? (_openBlock(), _createBlock("div", _hoisted_114, [
                                    _createVNode("div", _hoisted_115, [
                                      _createVNode("div", _hoisted_116, [
                                        _createVNode("span", _hoisted_117, _toDisplayString(_ctx.$t('existingOrder.QTY')) + ":", 1),
                                        _withDirectives(_createVNode("input", {
                                          "onUpdate:modelValue": ($event: any) => (customer.editQuantity = $event),
                                          type: "text",
                                          onInput: ($event: any) => (_ctx.debounce(() => _ctx.calculateCustomerRowHandler(customer, product.productId), 400)),
                                          onKeypress: _cache[25] || (_cache[25] = ($event: any) => (_ctx.isNumber($event))),
                                          onFocus: ($event: any) => (
                                                            customer.editQuantity = customer.editQuantity == 0 ? '' : customer.editQuantity
                                                        ),
                                          onBlur: ($event: any) => (
                                                            customer.editQuantity = customer.editQuantity == '' ? 0 : customer.editQuantity
                                                        ),
                                          class: "bookit-input product-input form-control h39"
                                        }, null, 40, ["onUpdate:modelValue", "onInput", "onFocus", "onBlur"]), [
                                          [_vModelText, customer.editQuantity]
                                        ])
                                      ]),
                                      _createVNode("div", _hoisted_118, [
                                        _createVNode("span", _hoisted_119, _toDisplayString(_ctx.$t('newOrder.perUnit')) + ":", 1),
                                        (_ctx.canChangeUnitPrice)
                                          ? (_openBlock(), _createBlock(_component_InputNumber, {
                                              key: 0,
                                              required: "",
                                              onInput: ($event: any) => (_ctx.debounce(() => _ctx.calculateCustomerRowHandler(customer, product.productId), 400)),
                                              class: "order-priceForOne-input",
                                              modelValue: customer.editUnitPrice,
                                              "onUpdate:modelValue": ($event: any) => (customer.editUnitPrice = $event),
                                              mode: 'decimal',
                                              minFractionDigits: 2,
                                              maxFractionDigits: 2,
                                              min: 0,
                                              allowEmpty: false,
                                              suffix: ' ' + _ctx.order.currencySymbol
                                            }, null, 8, ["onInput", "modelValue", "onUpdate:modelValue", "suffix"]))
                                          : (_openBlock(), _createBlock("span", _hoisted_120, _toDisplayString(customer.priceForOne) + " " + _toDisplayString(_ctx.order.currencySymbol), 1))
                                      ]),
                                      _createVNode("div", _hoisted_121, [
                                        _createVNode("span", _hoisted_122, _toDisplayString(_ctx.$t('label.discount')), 1),
                                        _withDirectives(_createVNode("input", {
                                          disabled: customer.couponId && _ctx.isNew,
                                          "onUpdate:modelValue": ($event: any) => (customer.editDiscountAmount = $event),
                                          type: "text",
                                          onInput: ($event: any) => (
                                                            _ctx.debounce(() => _ctx.calculateCustomerRowHandler(customer, product.productId, true), 400)
                                                        ),
                                          onKeypress: _cache[26] || (_cache[26] = ($event: any) => (_ctx.isDecimalNumber($event))),
                                          onFocus: ($event: any) => (
                                                            customer.editDiscountAmount =
                                                                customer.editDiscountAmount == 0 ? '' : customer.editDiscountAmount
                                                        ),
                                          onBlur: ($event: any) => (
                                                            customer.editDiscountAmount =
                                                                customer.editDiscountAmount == '' ? 0 : customer.editDiscountAmount
                                                        ),
                                          class: "bookit-input product-input form-control h39"
                                        }, null, 40, ["disabled", "onUpdate:modelValue", "onInput", "onFocus", "onBlur"]), [
                                          [_vModelText, customer.editDiscountAmount]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_123, [
                                      _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.total')) + ":", 1),
                                      _createVNode("span", null, _toDisplayString(_ctx.formatAmount(customer.editTotalAmount)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                                    ]),
                                    _createVNode("div", _hoisted_124, [
                                      _createVNode("div", null, [
                                        _createVNode("button", {
                                          class: "customer-edit-action-cancel",
                                          onClick: ($event: any) => {customer.editMode = false; customer.externalCouponEditConfirmed = false},
                                          type: "button"
                                        }, _toDisplayString(_ctx.$t('button.cancel')), 9, ["onClick"])
                                      ]),
                                      _createVNode("div", null, [
                                        _createVNode("button", {
                                          class: "customer-edit-action-save",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.saveOrderCustomer(customer, product.productId))
                                        }, _toDisplayString(_ctx.$t('button.save')), 9, ["onClick"])
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_125, [
                                    _createVNode("div", _hoisted_126, [
                                      _createVNode("div", _hoisted_127, _toDisplayString(_ctx.$t('existingOrder.QTY')) + ":", 1),
                                      _createVNode("div", _hoisted_128, _toDisplayString(customer.quantity), 1)
                                    ]),
                                    _createVNode("div", _hoisted_129, [
                                      _createVNode("div", _hoisted_130, _toDisplayString(_ctx.$t('newOrder.perUnit')) + ":", 1),
                                      _createVNode("div", _hoisted_131, _toDisplayString(customer.priceForOne) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                                    ]),
                                    _createVNode("div", _hoisted_132, [
                                      _createVNode("div", _hoisted_133, _toDisplayString(_ctx.$t('label.discount')), 1),
                                      _createVNode("div", _hoisted_134, _toDisplayString(_ctx.formatAmount(customer.discountAmount)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                                    ]),
                                    _createVNode("div", _hoisted_135, [
                                      _createVNode("div", _hoisted_136, _toDisplayString(_ctx.$t('newOrder.total')) + ":", 1),
                                      _createVNode("div", _hoisted_137, _toDisplayString(_ctx.formatAmount(customer.price)) + " " + _toDisplayString(_ctx.order.currencySymbol), 1)
                                    ])
                                  ])),
                              (!customer.editMode)
                                ? (_openBlock(), _createBlock("i", {
                                    key: 2,
                                    onClick: ($event: any) => (_ctx.customerEdit(customer)),
                                    class: "icon-f icon-pencil-edit fs-20"
                                  }, null, 8, ["onClick"]))
                                : (_openBlock(), _createBlock("span", {
                                    key: 3,
                                    class: "icon-f icon-trashcan trashcan fs-23",
                                    onClick: ($event: any) => (_ctx.removeProductCustomer(customer, product.productId, customerIndex))
                                  }, null, 8, ["onClick"]))
                            ])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
        ]),
        _createVNode("div", _hoisted_138, [
          _createVNode("div", _hoisted_139, _toDisplayString(_ctx.$t('order.remarks')), 1),
          _createVNode("div", _hoisted_140, [
            (_ctx.order.remarks)
              ? (_openBlock(), _createBlock("div", _hoisted_141, [
                  _createVNode("div", _hoisted_142, [
                    _createVNode("i", {
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.changeRemarks())),
                      class: "icon-f icon-pencil-edit fs-20"
                    })
                  ]),
                  _createVNode("span", null, _toDisplayString(_ctx.order.remarks), 1)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_143, [
                  _createVNode("button", {
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.changeRemarks())),
                    type: "button"
                  }, _toDisplayString(_ctx.$t('order.addRemark')), 1)
                ]))
          ])
        ]),
        (!_ctx.isQuote)
          ? (_openBlock(), _createBlock("div", _hoisted_144, [
              _createVNode("div", _hoisted_145, [
                _createVNode("div", _hoisted_146, [
                  _createVNode("div", _hoisted_147, [
                    _createVNode("div", _hoisted_148, [
                      _createVNode("span", _hoisted_149, _toDisplayString(_ctx.$t('title.tags')) + ": ", 1),
                      _createVNode("span", {
                        onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.openTagsManagementModal && _ctx.openTagsManagementModal(...args))),
                        class: "text-link d-block d-lg-none",
                        style: {"margin-bottom":"5px"}
                      }, _toDisplayString(_ctx.$t('label.tags-management')), 1)
                    ]),
                    _createVNode("div", _hoisted_150, [
                      _createVNode("span", {
                        onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.openTagsManagementModal && _ctx.openTagsManagementModal(...args))),
                        class: "text-link d-none d-lg-inline",
                        style: {"margin-inline-end":"28px"}
                      }, _toDisplayString(_ctx.$t('label.tags-management')), 1),
                      _createVNode("button", {
                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.openAddTagsModal && _ctx.openAddTagsModal(...args))),
                        class: "add-tag-btn",
                        type: "button"
                      }, [
                        _hoisted_151,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('label.add-tags')), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_152,
              _createVNode("div", _hoisted_153, [
                _createVNode("div", _hoisted_154, [
                  _createVNode("div", _hoisted_155, [
                    _createVNode("div", _hoisted_156, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order.tags, (tag) => {
                        return (_openBlock(), _createBlock("div", {
                          key: tag.id,
                          class: "order-tag d-flex justify-content-between"
                        }, [
                          _createVNode("span", _hoisted_157, _toDisplayString(tag.name), 1),
                          _createVNode("span", {
                            class: "marker-remove",
                            onClick: ($event: any) => (_ctx.removeTagFromOrder(tag))
                          }, null, 8, ["onClick"])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isNew && !_ctx.isQuote)
          ? (_openBlock(), _createBlock("div", _hoisted_158, [
              _createVNode("div", _hoisted_159, [
                _createVNode("p", _hoisted_160, _toDisplayString(_ctx.$t('orders.messages')), 1),
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.changeChatType('CHAT'))),
                  class: ["circle-button btn-blue btn-48 flex-center mx-1", { checked: _ctx.filterType == 'CHAT' }]
                }, [
                  _hoisted_161
                ], 2),
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.changeChatType('SYSTEM'))),
                  class: ["circle-button btn-blue btn-48 flex-center mx-2", { checked: _ctx.filterType == 'SYSTEM' }]
                }, [
                  _hoisted_162
                ], 2),
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.changeChatType('ALL'))),
                  class: ["circle-button btn-blue btn-48 flex-center mx-1", { checked: _ctx.filterType == 'ALL' }]
                }, _toDisplayString(_ctx.$t('order.chatFilterTypeButton.all')), 3)
              ]),
              _createVNode("div", _hoisted_163, [
                _createVNode("div", _hoisted_164, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order.messages, (row) => {
                    return (_openBlock(), _createBlock("div", {
                      class: ["message-item", 
                                    row.isMe ? 'from-me' : row.type == 1 ? 'from-system' : row.type == 3 ? 'from-customer' : 'from-user'
                                ],
                      key: row.id
                    }, [
                      _createVNode("div", _hoisted_165, [
                        (row.type == 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_166, "System" + _toDisplayString(row.from ? ` (${row.from}),` : ','), 1))
                          : (row.type == 2)
                            ? (_openBlock(), _createBlock("span", _hoisted_167, _toDisplayString(row.from) + ",", 1))
                            : (row.type == 3)
                              ? (_openBlock(), _createBlock("span", _hoisted_168, "Customer,"))
                              : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatChatDate(row.createDate)), 1)
                      ]),
                      _createVNode("div", _hoisted_169, [
                        (row.type == 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_170, _toDisplayString(_ctx.$t(row.message, row.messageValues || {})), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_171, _toDisplayString(row.message), 1))
                      ])
                    ], 2))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_172, [
                  _withDirectives(_createVNode("textarea", {
                    class: "w-100",
                    type: "text",
                    id: "textMessage",
                    placeholder: _ctx.$t('placeholder.typeMessageHere'),
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.message = $event)),
                    onInput: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.adjustTextareaHeight && _ctx.adjustTextareaHeight(...args))),
                    onKeydown: [
                      _cache[37] || (_cache[37] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMsg && _ctx.sendMsg(...args)), ["exact"]), ["enter"])),
                      _cache[38] || (_cache[38] = _withKeys(_withModifiers(($event: any) => (_ctx.message += '\n'), ["shift","exact"]), ["enter"]))
                    ]
                  }, null, 40, ["placeholder"]), [
                    [_vModelText, _ctx.message]
                  ]),
                  _createVNode("div", {
                    class: "chat-send-button",
                    onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.sendMsg && _ctx.sendMsg(...args)))
                  }, [
                    _hoisted_173
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_OrderMobileActionsFooter, {
          key: 4,
          submitText: _ctx.$t('button.create'),
          "from-id": 'new-order-form-id',
          calculated: true,
          onBackEmit: _cache[40] || (_cache[40] = ($event: any) => (_ctx.back()))
        }, null, 8, ["submitText"]))
      : _createCommentVNode("", true),
    (_ctx.showContractFormModal)
      ? (_openBlock(), _createBlock(_component_OverlayModal, {
          key: 5,
          isOpen: true
        }, {
          default: _withId(() => [
            _createVNode(_component_ContractFormModal, {
              "lead-customer": _ctx.order.leadCustomer,
              onUpdateVisibility: _ctx.updateContractFormModalVisibility,
              onConfirmed: _ctx.contractFormModalConfirmed
            }, null, 8, ["lead-customer", "onUpdateVisibility", "onConfirmed"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_AddTagsModal, {
      ref: "addTagsModal",
      tags: _ctx.orderTags,
      onOnSave: _ctx.onSaveTagsHandler
    }, null, 8, ["tags", "onOnSave"]),
    _createVNode(_component_TagsManagementModal, {
      ref: "tagsManagementModal",
      tags: _ctx.orderTags,
      onOnSave: _ctx.onSaveTag,
      onOnDelete: _ctx.onDeleteTag
    }, null, 8, ["tags", "onOnSave", "onOnDelete"]),
    _createVNode(_component_CrmCustomerChatMessagePopup, {
      ref: "modalCrmCustomerChatMessage",
      onMessageSend: _cache[41] || (_cache[41] = ($event: any) => (_ctx.getNextMessages()))
    }, null, 512)
  ], 2)), [
    [_vShow, _ctx.loaded]
  ])
})